import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchTests } from "../../actions/testActions";
import ExamCards from "./ExamCards";
import { Spinner } from "react-bootstrap";
import SEO from "../common/SEO";
import { slug as slugify } from 'github-slugger';

function TestSeriesFilter() {
    const { series } = useParams(); // Get the testseries name from the URL


    const dispatch = useDispatch();
    const testsData = useSelector(state => state.tests.tests);
    const loading = useSelector(state => state.tests.loading);
    const studentProfileData = useSelector(state => state.dashboard.userData);
    const paginated = false;

    useEffect(() => {
        if (!testsData || testsData.length === 0 || testsData.length === 10) {
           dispatch(fetchTests(1, 100, null, '', paginated)); // Fetch tests data when the component mounts
        }
    }, []); 

    // Filter exams based on the testseries name
    const filteredExams = testsData.filter((exam) => exam?.testSeries?.toLowerCase() === series.toLowerCase());
    // Handle test attempt (example function)
    const navigate = useNavigate();
    const handleAttemptTest = async (test) => {
        navigate(`/exam-terms-conditions`, { state: { test, studentProfileData } });

    };

    // Generate SEO data based on the test series
    const generateSeoData = () => {
        const testCount = filteredExams.length;
        const seriesName = series.toUpperCase();

        const title = `${seriesName} Test Series - Practice Exams | My Exam World`;
        const description = `Prepare with our ${seriesName} test series. Access ${testCount} practice exams, mock tests, and comprehensive assessment materials for ${seriesName} exam preparation.`;

        // Extract test titles for keywords (limited to first 5)
        const testTitles = filteredExams.slice(0, 5).map(test => test.title) || [];
        const keywords = `${seriesName} test series, ${seriesName} exams, ${seriesName} practice tests, ${seriesName} mock tests, ${testTitles.join(', ')}, exam preparation, online assessment`;

        return {
            title,
            description: description.substring(0, 160),
            keywords: keywords.substring(0, 255),
            url: `/testseries/${series.toLowerCase()}`
        };
    };

    const seoData = generateSeoData();


    return (

        <>
            {/* SEO Component */}
            <SEO
                title={seoData.title}
                description={seoData.description}
                keywords={seoData.keywords}
                url={seoData.url}
                schema={{
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "name": `${series ? series.toUpperCase() : ''} Test Series`,
                    "numberOfItems": filteredExams.length,
                    "itemListElement": filteredExams.slice(0, 10).map((test, index) => ({
                        "@type": "ListItem",
                        "position": index + 1,
                        "name": test.testName || test.title,
                        "url": `https://www.myexamworld.com/test/${slugify(test.testName || test.title)}/${test._id || test.id}`
                    }))
                }}
            />

            {
                loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '30vh', color: '#0096c7' }}>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>

                ) :
                    <div className="container mt-4" >
                        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                            <h2 className="col-md-12 text-center">{series.toUpperCase()} TEST EXAMS</h2>
                            {filteredExams.length > 0 ? (
                                filteredExams.map((test, index) => (

                                    <ExamCards
                                        key={index}
                                        index={index}
                                        test={test}
                                        onAttemptTest={handleAttemptTest} // Pass the handler function
                                    />
                                ))
                            ) : (
                                <p className="col-md-12 text-center">No exams found for the selected test series.</p>
                            )}
                        </div>
                    </div>
            }

        </>
    );
}

export default TestSeriesFilter;